@use "diy_base.module.scss";
@use "foundation/_colors.scss";
@use "foundation/responsive";
@use "sass:math";

.filter-code {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;

  $max-side-padding: 2.25em;
  $side-padding-step: calc($max-side-padding / 2);

  overflow-y: hidden;
  width: 100%;
  height: calc(100vh - 120px);
  padding: 0 $side-padding-step;
  font-size: 1em;

  .left-panel,
  .right-panel {
    padding-top: 1.25em;
  }

  .left-panel {
    display: flex;
    flex-direction: column;

    width: math.percentage(math.div(2, 3));
    padding-left: $side-padding-step;
    padding-right: 20px;
    border-right: 1px solid colors.$neutrals-light-grey;
  }

  .right-panel {
    width: math.percentage(math.div(1, 3));
    height: 100%;
    overflow-y: auto;
    padding-right: $side-padding-step;
    padding-left: 20px;
  }

  .cta {
    position: absolute;
    top: 1.55em;
    right: 2.25em;
  }

  .generators {
    ul li {
      display: flex;
      align-items: center;
      gap: 0.35em;

      > a {
        font-size: 0.7em;
      }
    }

    .proPlusBadge {
      display: inline-flex;
      align-items: center;
      flex-shrink: 0;

      svg {
        height: 18px;
        display: block;
      }
    }
  }
}
